<template>
  <transition name="fadeInOut">
    <div class="home" v-if="isInit">
      <home-bg-eff/>
      <div class="search-box">
        <input class="input-box" v-model="inputStr" placeholder="搜索你想了解的课程" ref="inputBox"/>
        <div class="search-btn" @click="search">
          <div class="btn-1"></div>
          <div class="btn-2"></div>
        </div>
        <transition name="expandToRight">
          <div class="clear-btn" v-show="inputStr" @click="clearInput">清除输入内容</div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>

import HomeBgEff from '@/components/HomeBgEff'

export default {
  name: 'Home',
  components: {
    HomeBgEff
  },
  path: 'home',
  data () {
    return {
      isInit: false,
      inputStr: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.isInit = true
      this.$nextTick(() => {
        document.onkeypress = (event) => {
          const e = event
          if (e && e.keyCode === 13 && (this.$refs.inputBox === document.activeElement)) { // 回车键的键值为13
            this.search()
          }
        }
      })
    },
    search () {
      const str = this.inputStr
      if (str === '') { return }
      const params = {
        type: 0,
        text: str
      }
      this.$router.push({
        path: '/search' + '?_=' + (new Date()).getTime(),
        query: params
      })
    },
    clearInput () {
      this.inputStr = ''
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .search-box {
    width: 40%;
    min-width: 500px;
    height: 50px;
    border-radius: 15px;
    background-color: white;
    position: absolute;
    top: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .input-box {
      height: 90%;
      width: 90%;
      margin-left: 10px;
      border: 0;
      outline: none;
      cursor: none;
      font-size: 35px;
      line-height: 36px;
    }
    .clear-btn {
      color: white;
      background-color: red;
      position: absolute;
      font-size: 18px;
      bottom: -35px;
      padding: 0 5px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      height: 26px;
    }
    .search-btn {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      position: relative;
      .btn-1 {
        position: absolute;
        width: 22px;
        height: 22px;
        border-radius: 22px;
        border: 3px solid black;
        left: 10px;
        top: 10px;
      }
      .btn-2 {
        position: absolute;
        width: 9px;
        height: 3px;
        background-color: black;
        border-radius: 3px;
        transform: rotate(45deg);
        left: 33px;
        top: 34px;
      }
    }
  }
}
</style>
